<template>
    <button
        v-if="componentStyles"
        :style="componentStyles"
        type="button"
        class="a-scroll-button"
        @click="handleClick"
    >
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "AScrollButton",
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.AScrollButton.styles`) || null;
        }
    },
    methods: {
        handleClick() {
            this.$emit('onClick');
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>